import Spinner from "@/components/Spinner/Spinner.vue";
import { mapGetters, mapActions } from "vuex";
import authService from "@/services/auth";
import { ALERT_TYPES } from "@/constants/variables";
import Utils from "@/mixins/Utils";
import documentService from "@/services/document";
import { COMPONENT_KEYWORD, SCREEN_NAME } from "@/constants/variables";
import { analytics } from "@/services/firebase";
var platform = require("platform");

export default {
  data() {
    return {
      email: this.$route.query.email || "",
      password: "",
      alert: {},
      wantsToLogin: !this.$route.query.forgotPwd,
      createAdvPassword: false,
      newAdvEmail: "",
      forgotPwdError: false,
      refusedImgUrl: "",
      forgotEmailImgUrl: "",
      forgotPwdNoInternet: false,
      forgotPwdEmailSent: false,
      forgotPwdEmailSentImgUrl: "",
      showForgoPwdBtn: true,
    };
  },
  mixins: [Utils],
  components: {
    Spinner,
  },
  computed: {
    ...mapGetters({
      errorMessage: "errorMessage",
      loadingSpinner: "isLoading",
      successMessage: "successMessage",
    }),
    ...mapGetters("auth", {
      loginErrorMessage: "loginErrorMessage",
    }),
    ...mapGetters("supportTechnique", {
      appVersion: "appVersion",
    }),
    ...mapGetters("auth", {
      isReturnLogin: "isReturnLogin",
    }),
    device() {
      return platform.description.split("on")[1];
    },
    browser() {
      return platform.description.split("on")[0];
    },
    isValidEmail() {
      // Simple email regex
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    },
  },
  methods: {
    getForgotEmailImg() {
      documentService
        .getComponentBykeyword({
          keyword: COMPONENT_KEYWORD.FORGOT_PWD_EMAIL_INPUT_IMAGE,
        })
        .then((res) => {
          if (res && res.components) {
            this.forgotEmailImgUrl = res.components[0].urlFile;
          }
        });
    },
    getForgotPwdEmailSentImg() {
      documentService
        .getComponentBykeyword({
          keyword: COMPONENT_KEYWORD.FORGOT_PWD_EMAIL_SENT_IMAGE,
        })
        .then((res) => {
          if (res && res.components) {
            this.forgotPwdEmailSentImgUrl = res.components[0].urlFile;
          }
        });
    },
    getActivationConditions() {
      return authService
        .getActivationConditions()
        .then((res) => {
          if (res && res.activation) {
            this.showForgoPwdBtn = res.activation['rcfforgotpwd'];
          }
        })
        .catch((err) => {});
    },

    getRefuseImg() {
      documentService
        .getComponentBykeyword({
          keyword: COMPONENT_KEYWORD.REFUSED_IMAGE_WEB,
        })
        .then((res) => {
          if (res && res.components) {
            this.refusedImgUrl = res.components && res.components.length > 0 ? res.components.find(component => component.appName === '2').urlFile : '';
          }
        });
    },
    ...mapActions("auth", {
      loginManually: "LOGIN_MANUALLY",
    }),
    submit() {
      const data = {
        version: this.appVersion,
        os: this.browser,
        username: this.email,
        password: this.password,
      };
      this.loginManually(data);
    },
    isValidForm() {
      const vue = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          vue.submit();
        }
      });
    },

    resetForgotPwdNoInternet() {
      this.forgotPwdNoInternet = false;
      // Optionally reset other form state
    },
    onCancel() {
      if (this.$refs["my-modal"]) {
        this.$refs["my-modal"].hide();
      }
    },
    recoverPassword() {
      const vue = this;
      authService
        .recoverPassword(this.email)
        .then((res) => {
          const variant = res.success
            ? ALERT_TYPES.SUCCESS
            : ALERT_TYPES.DANGER;
          const message = res.message;

          vue.onSetAlert(true, variant, message);
        })
        .catch((err) => {
          // Handle with error
        });
    },

    trackForgotPasswordScreen() {
      analytics.logEvent("screen_view", {
        screen_name: SCREEN_NAME.FORGOT_PASSWORD,
        platform: 'web'
      });
    },
    trackEmailSentScreen() {
      analytics.logEvent("screen_view", {
        screen_name:SCREEN_NAME.EMAIL_SENT,
         platform: 'web'
      });
    },
    updatePassword(isForgotPassword) {
      const vue = this;
      const data = {
        isCreation: !isForgotPassword,
        email: isForgotPassword ? this.email : this.newAdvEmail,
        source: this.createAdvPassword ? undefined : 2,
      };
      authService
        .createRecoveryPassword(data)
        .then((res) => {
          if (res.success) {
            if (this.createAdvPassword) {
              const variant = res.success
                ? ALERT_TYPES.SUCCESS
                : ALERT_TYPES.DANGER;
              const message = res.message;

              vue.onSetAlert(true, variant, message);
              vue.$refs["my-modal"].show();
            } else {
              vue.forgotPwdEmailSent = true;
              vue.forgotPwdError = false;
              vue.forgotPwdNoInternet = false;
              vue.trackEmailSentScreen();
              vue.trackForgotPasswordScreen();
            }
          } else {
            if (this.createAdvPassword) {
              vue.$refs["my-modal"].show();
            } else {
              vue.forgotPwdError = true;
            }
          }
        })
        .catch((err) => {
          if (!navigator.onLine || err.message === "Network Error") {
            vue.forgotPwdNoInternet = !this.createAdvPassword;
          } else {
            vue.forgotPwdError = !this.createAdvPassword;
          }
          // Show error screen for any API/network error
        });
    },
    createRecoverPassword(isForgotPassword) {
      const vue = this;
      if (vue.createAdvPassword) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.updatePassword(isForgotPassword);
          }
        });
      } else {
        this.updatePassword(isForgotPassword);
      }
    },

    onChangeView() {
      this.wantsToLogin = !this.wantsToLogin;
      this.createAdvPassword = false;
      this.forgotPwdNoInternet = false;
      this.forgotPwdError = false;
      this.forgotPwdEmailSent = false;
      this.onCancel();
      this.onSetAlert(false);
      if (this.$refs["my-modal"]) {
        this.$refs["my-modal"].hide();
      }
      this.$store.commit("auth/SET_SHOW_CONNECTION_BTN", !this.wantsToLogin);
      if (this.wantsToLogin === true) {
        this.email = "";
      }
    },
    onChangeCreatePasswordView() {
      this.createAdvPassword = !this.createAdvPassword;
      this.wantsToLogin = false;
      this.newAdvEmail = "";
      this.onSetAlert(false);
      this.$store.commit("auth/SET_SHOW_CONNECTION_BTN", true);
    },
    onSetAlert(isShow, variantType, msg) {
      this.alert = {
        variant: variantType,
        message: msg,
        show: isShow,
      };
    },
    goToLoginScreen() {
      this.forgotPwdNoInternet = false;
      this.forgotPwdError = false;
      this.forgotPwdEmailSent = false;
      this.wantsToLogin = true;
      this.alert.show = false;
      this.$store.commit("auth/SET_SHOW_CONNECTION_BTN", !this.wantsToLogin);
    },
    resetForgotPwdError() {
      this.forgotPwdNoInternet = false;
      this.forgotPwdError = false;
      this.forgotPwdEmailSent = false;
    },
    openMailClient() {
      // This will open the default mail client
      window.location.href = "mailto:";
    },

  },
  watch: {
    loginErrorMessage: function(val) {
      if (val) {
        this.onSetAlert(true, ALERT_TYPES.DANGER, val);
      }
    },
    successMessage: function(val) {
      if (val) {
        this.onSetAlert(true, ALERT_TYPES.SUCCESS, val);
      }
    },
    isReturnLogin: function(val) {
      if (val !== undefined) {
        this.wantsToLogin = true;
        this.createAdvPassword = false;
      }
    },
  },
  created() {
    this.getRefuseImg();
    this.getForgotEmailImg();
    this.getForgotPwdEmailSentImg();
    this.getActivationConditions();
    console.log("Params: ", this.$route.params);
  },
};
